import axios from 'axios'
import { useUserStore } from '@/stores/user'

const apiBase = 'https://ncht.bz'

function http() {
  const userStore = useUserStore()
  return axios.create({
    baseURL: `${apiBase}/api/sheet-exports`,
    headers: {
      Authorization: `Bearer ${userStore.token}`,
    },
  })
}

export const DEFAULT_TEMPLATE = {
  name: 'Аналитика 9 запуска | Анкета слет декабрь',
  process_url: 'https://get-nechto.ru/pl/tasks/mission/update?id=2602294',
  spreadsheet: '1opTg0i5AsmAjCsQzgxusnzbElVjXvgEOX1LaEDLs9vk',
  sheet_name: 'Анкета слет декабрь',
  mapping: {
    name: 'Пользователь',
    email: 'Email',
    phone: 'Телефон',
    username: 'tg_username',
    utm_source: 'utm_source',
    utm_medium: 'utm_medium',
    utm_campaign: 'utm_campaign',
    utm_content: 'utm_content',
    utm_term: 'utm_term',
    number: 'Номер заказа',
    date: 'Дата создания',
    cost_money: '',
    payed_money: '',
    sb_id: 'sb_id',
    tg_id: 'tg_id',
  },
}

export function cloneDefaultTemplate() {
  return JSON.parse(JSON.stringify(DEFAULT_TEMPLATE))
}

export const sheetExportsApi = {
  list: () => http().get('/'),
  meta: () => http().get('/meta'),
  create: (payload) => http().post('/', payload),
  update: (id, payload) => http().put(`/${id}`, payload),
  remove: (id) => http().delete(`/${id}`),
  rotateToken: (id) => http().post(`/${id}/rotate-token`),
  checkSheet: (payload) => http().post('/check-sheet', payload),
  log: (id) => http().get(`/${id}/log`),
  test: (id) => http().post(`/${id}/test`),
}
